<pos-app-spinner [show]="loading"></pos-app-spinner>
<mat-drawer-container [hasBackdrop]="false">
  <mat-drawer *ngIf="loggedinUserId$ | async as loggedInUserId" #drawer mode="side" class="drawernav">
    <div
      class="logo-container-p"
      id="logoContainer"
      style="
        display: fixed;
        position: fixed;
        background-color: grey;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
      "
      [ngStyle]="{ width: menuDisplayPreference === 'MAX' ? '240px' : '240px' }"
    >
      <div class="logo-container-wrapper" (click)="navigateToHome()">
        <div class="logo-image"></div>
        &nbsp;<span class="logo-text-tb">CENTRAL</span>
      </div>
      <div class="d-flex row justify-content-center" style="background-color: grey; margin-right: 2px">
        <div class="d-flex justify-content-center text-uppercase">
          {{ loggedinUserName$ | async }}
        </div>
        <div *ngIf="role$ | async as role">
          <div
            class="d-flex justify-content-center text-uppercase"
            style="font-size: 12px"
            *ngIf="forInternalUser(role) || role === USER_ROLE.showExternal"
          >
            {{ (defaultBranch$ | async).BranchDescription }}
            <button
              *ngIf="forInternalUserOnly(role) && !isElectron"
              class="btn btn-cancel"
              style="height: 20px; margin-top: -2px"
              (click)="switchBranch()"
            >
              <mat-icon style="margin-top: -8px"> compare_arrows </mat-icon>
            </button>
          </div>
          <div
            class="d-flex justify-content-center text-uppercase"
            style="font-size: 12px"
            *ngIf="role === USER_ROLE.external || role === USER_ROLE.programme"
          >
            {{ jdeSession?.CustomerName }}
          </div>
        </div>
      </div>
    </div>

    <!-- control when display menu is max icon only -->

    <pos-app-nav-bar
      *ngIf="menuDisplayPreference === 'MAX'"
      [hoverStatus]="true"
      (setMenuDisplayPreference)="setDisplayPreference($event)"
      [menuDisplayPreference]="menuDisplayPreference"
      [isShowArbAccountSubMenu]="isShowArbAccountSubMenu"
      [isShowPreferencesSubMenu]="isShowPreferencesSubMenu"
      (setShowArbAccountSubMenu)="setShowArbAccountSubMenu($event)"
      (setShowPreferencesSubMenu)="setShowPreferencesSubMenu($event)"
    ></pos-app-nav-bar>
  </mat-drawer>
  <mat-drawer-content class="content-container">
    <section
      *ngIf="!menuHide && loggedinUserId$ | async as loggedInUserId"
      class="section1"
      style="width: 60px; height: 100%; overflow: hidden; overflow-y: scroll; scrollbar-width: none; -ms-overflow-style: none"
      (scroll)="onScroll($event)"
    >
      <style>
        .section1::-webkit-scrollbar {
          display: none;
        }
      </style>
      <div
        class="logo-container-p"
        style="display: fixed; position: fixed; background-color: grey; z-index: 1000"
        [ngStyle]="{ width: menuDisplayPreference === 'MIN' ? '60px' : '60px' }"
      >
        <div class="logo-container-wrapper" (click)="navigateToHome()">
          <div class="logo-image-small"></div>
          <span class="logo-text-small">CENTRAL</span>
        </div>
        <div class="d-flex justify-content-center text-white background-color: grey m-2">
          <div
            style="
              background-color: black;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              border: 2px solid white;
              display: flex;
              font-size: 16px;
              align-items: center;
              justify-content: center;
              padding: 4px;
              font-weight: bold;
            "
          >
            <span class="text-uppercase">{{ (loggedinUserName$ | async)?.split(' ')[0]?.charAt(0) }}</span>
            <span class="text-uppercase">{{ (loggedinUserName$ | async)?.split(' ')[1]?.charAt(0) }}</span>
          </div>
        </div>
        <div
          *ngIf="forInternalUserOnly(role$ | async) && !isElectron"
          class="d-flex justify-content-center text-uppercase"
          style="margin-top: -6px; margin-left: -4px; color: white"
        >
          <button class="btn btn-cancel" style="height: 20px">
            <mat-icon style="margin-top: -8px" (click)="switchBranch()"> compare_arrows </mat-icon>
          </button>
        </div>
      </div>
      <!-- control when display menu is min icon only -->
      <pos-app-nav-bar
        *ngIf="menuDisplayPreference === 'MIN' || menuDisplayPreference === 'initial' || menuDisplayPreference === 'AUTO'"
        [hoverStatus]="false"
        (setMenuDisplayPreference)="setDisplayPreference($event)"
        (setTempMenuDisplayPreference)="setTempDisplayPreference($event)"
        [menuDisplayPreference]="menuDisplayPreference"
        [isShowArbAccountSubMenu]="isShowArbAccountSubMenu"
        [isShowPreferencesSubMenu]="isShowPreferencesSubMenu"
        (setShowArbAccountSubMenu)="setShowArbAccountSubMenu($event)"
        (setShowPreferencesSubMenu)="setShowPreferencesSubMenu($event)"
      ></pos-app-nav-bar>
    </section>
    <section class="section2">
      <!-- <div *ngIf="showSpotlightNav && loggedinUserId$ | async as loggedInUserId" class="product-spotlight">
        <pos-app-product-spotlight #spotlightElement (navigateToHomeEvent)="navigateToHome(true)"></pos-app-product-spotlight>
      </div> -->
      <router-outlet></router-outlet>
    </section>
  </mat-drawer-content>
</mat-drawer-container>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">CHANGE BRANCH</h3>
  </div>
  <div class="modal-body">
    <form [formGroup]="changeBranchForm" class="form-horizontal">
      <div class="form-group">
        <div class="row align-items-center">
          <div class="col-md-5">
            <label for="currentBranch">CURRENT BRANCH</label>
            <input
              id="currentBranch"
              type="text"
              class="form-control"
              [value]="(defaultBranch$ | async)?.BranchCode + ' - ' + (defaultBranch$ | async)?.BranchDescription"
              disabled
            />
          </div>
          <div class="col-md-2 d-flex justify-content-center align-items-center" style="height: 100%">
            <mat-icon>compare_arrows</mat-icon>
          </div>
          <div class="col-md-5">
            <label for="branch">BRANCH</label>
            <ng-select id="branch" formControlName="branchCode" [clearable]="false">
              <ng-option *ngFor="let branch of branchList" [value]="branch.BranchCode"
                >{{ branch.BranchCode }} - {{ branch.BranchDescription }}</ng-option
              >
            </ng-select>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn" (click)="submitChangeBranch()" [disabled]="changeBranchForm.invalid">CHANGE BRANCH</button>
        <button class="btn btn-cancel" (click)="cancel()">CANCEL</button>
      </div>
    </form>
  </div>
</ng-template>
